/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCurrencyIls = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9 1c3.86 0 7 3.141 7 7v8h-2V8c0-2.757-2.243-5-5-5H5v20H3V1zm12 0v22h-6c-3.86 0-7-3.141-7-7V8h2v8c0 2.757 2.243 5 5 5h4V1z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCurrencyIls as CurrencyIls };
